import axios from "@/plugins/http";
import { SMQuestionnaire, SMTasks } from "@/store";
import { API_ROUTES } from "@/utils/API";
import { Action, Module, VuexModule } from "vuex-module-decorators";

@Module({ name: "MRoles", namespaced: true })
export default class MRoles extends VuexModule {
  @Action
  async createRoleTemplate(fromSL = false) {
    const { data } = await axios.get(API_ROUTES.CREATE_ROLE_TEMPLATE(fromSL));

    const { user_flow_id, target_id } = data;

    SMTasks.setRoleFlow(user_flow_id);

    SMQuestionnaire.setAnswerQuery({ target_id });

    if (!SMTasks.taskUserflow) return;

    await SMQuestionnaire.openQuestionnaire(SMTasks.taskUserflow);
  }

  @Action
  async editRoleTemplate({ target_id, user_flow_id }: { target_id: number; user_flow_id: number }) {
    await SMTasks.setRoleFlow(user_flow_id);

    await SMQuestionnaire.setAnswerQuery({ target_id });

    if (!SMTasks.taskUserflow) return;

    await SMQuestionnaire.openQuestionnaire(SMTasks.taskUserflow);
  }
}
